import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="w-full py-14 md:py-20 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Korean%20manhwa%20art%20style%20warm%20atmospheric%20scene%2C%20cozy%20reading%20nook%20with%20soft%20candlelight%2C%20open%20book%20and%20warm%20tea%2C%20golden%20hour%20lighting%20through%20window%2C%20peaceful%20and%20inviting%20mood%2C%20rich%20dark%20wood%20tones%20and%20warm%20amber%20highlights&width=1920&height=800&seq=cta-bg-2026&orientation=landscape')`,
        }}
      >
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-background-900/90 via-background-900/80 to-background-900/90"></div>

      <div className="relative z-10 w-full max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-bold font-heading text-white mb-4">
          立即开启你的韩漫之旅
        </h2>
        <p className="text-background-300 text-sm md:text-base mb-8 max-w-xl mx-auto leading-relaxed">
          海量韩国漫画等你来发现，下拉式阅读带来极致体验。加入850万读者，一起享受精彩故事！
        </p>
        <Link
          to="/category/romance"
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-500 text-white rounded-full text-sm font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap shadow-lg hover:shadow-xl"
        >
          免费开始阅读
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}